import { render, staticRenderFns } from "./LegacyStatisticsPanel.vue?vue&type=template&id=b168af68"
import script from "./LegacyStatisticsPanel.vue?vue&type=script&lang=js"
export * from "./LegacyStatisticsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports